/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { readable_reward } from '../models/readable_reward';
import type { writtable_reward } from '../models/writtable_reward';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BasketService {
    /**
     * Get `Rewards` list of a member (a Reward is a clipped offer).
     *
     * @param memberId Member identifier
     * @param retailerId Retailer identifier to filter rewards
     * @param storeId Store identifier permits to apply product carried `!!JP ONLY!!`
     * @returns any Successful operation, returning found basket rewards.
     * @throws ApiError
     */
    public static getMembersBasket(
        memberId: number,
        retailerId?: number,
        storeId?: number,
    ): CancelablePromise<(readable_reward & {
        actual_expired_at?: string;
    })> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/members/{member_id}/basket',
            path: {
                'member_id': memberId,
            },
            query: {
                'retailer_id': retailerId,
                'store_id': storeId,
            },
        });
    }
    /**
     * Create a `Reward` = clip an offer in Member's Basket.
     *
     * @param memberId Member identifier
     * @param rewards
     * @returns any Successful operation.
     * @throws ApiError
     */
    public static postMembersBasket(
        memberId: number,
        rewards: Array<writtable_reward>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/members/{member_id}/basket',
            path: {
                'member_id': memberId,
            },
            body: rewards,
        });
    }
    /**
     * Delete a `Reward` in member's Basket.
     *
     * @param memberId Member identifier
     * @param rewardId Reward identifier
     * @returns any Successful deleted reward.
     * @throws ApiError
     */
    public static deleteMembersBasket(
        memberId: number,
        rewardId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/members/{member_id}/basket',
            path: {
                'member_id': memberId,
            },
            query: {
                'reward_id': rewardId,
            },
        });
    }
    /**
     * Clear a basket reward.
     *
     * @param memberId Member identifier
     * @param rewardId Reward identifier
     * @returns any Successful cleared reward.
     * @throws ApiError
     */
    public static patchMembersBasketClear(
        memberId: number,
        rewardId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/members/{member_id}/basket/clear',
            path: {
                'member_id': memberId,
            },
            query: {
                'reward_id': rewardId,
            },
        });
    }
    /**
     * Get `Rewards` list of a member (a Reward is a clipped offer).
     *
     * @param memberId Member identifier
     * @param retailerId Retailer identifier to filter rewards
     * @param storeId Store identifier permits to apply product carried `!!JP ONLY!!`
     * @param datePc Date format YYYYMMDD
     * @returns readable_reward Successful operation, returning found basket rewards.
     * @throws ApiError
     */
    public static getRtdMembersBasket(
        memberId: number,
        retailerId?: number,
        storeId?: number,
        datePc?: string,
    ): CancelablePromise<Array<readable_reward>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rtd/members/{member_id}/basket',
            path: {
                'member_id': memberId,
            },
            query: {
                'retailer_id': retailerId,
                'store_id': storeId,
                'date_pc': datePc,
            },
        });
    }
}
